<template>
    <div class="df_container-fluid fluid-width fluid-max buscador">
        <buscador ref="buscador"></buscador>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="vc_column-inner ">
                    <div class="wpb_wrapper">
                        <hr>
                        <h2 style="margin-top: 1em;">Resultados búsqueda</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="vc_row wpb_row vc_row-fluid criterioresumen" v-for="criterio in buscador.criterios.data">
            <div class="wpb_column vc_column_container vc_col-sm-3"><div class="vc_column-inner "><div class="wpb_wrapper">
                <h3 v-if="criterio.jurisdiccion != null">{{ criterio.jurisdiccion.nombre }}</h3>
                <h4 v-if="criterio.materia != null">{{ criterio.materia.nombre }}</h4>
                <h5 v-if="criterio.submateria != null">{{ criterio.submateria.nombre }}</h5>
            </div></div></div>
            <div class="wpb_column vc_column_container vc_col-sm-9"><div class="vc_column-inner "><div class="wpb_wrapper">
                <p>{{ criterio.descripcion }}</p>
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <router-link class="social" :to="{ name: 'criterio', params: { id: criterio.id }}">Ficha detalle</router-link>
                    </li>
                    <li class="list-inline-item float-right"><a :href="getFacebookUrl(criterio.id)" class="social" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li class="list-inline-item float-right">Compartir en: <a :href="getTwitterkUrl(criterio.id)" class="social" target="_blank"><i class="fa fa-twitter"></i></a></li>
                </ul>
            </div></div></div>
        </div>
        <paginador :data="buscador.criterios" @paginador-cambio-pagina="paginar"></paginador>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Buscador from '../components/Buscador';
    import Paginador from '../components/Paginador';

    export default {
        name: "Listado",
        components: { Buscador, Paginador },
        computed: mapState(['buscador']),
        methods: {
            paginar(page){
                this.$refs.buscador.clickBuscar(page);
            },
            getFacebookUrl(criterio){
                let url='https://www.facebook.com/sharer.php?u=';
                url+=encodeURIComponent(window.location.origin+this.$router.resolve({ name: 'criterio', params: { id: criterio }}).href);
                return url;
            },
            getTwitterkUrl(criterio){
                let url='https://twitter.com/share?url=';
                url+=encodeURIComponent(window.location.origin+this.$router.resolve({ name: 'criterio', params: { id: criterio }}).href);
                return url;
            }
        }
    }
</script>

<style>

</style>